// import { AsyncStorage } from 'react-native';
import axios from 'axios';

const isDebug = false;

let params = {};
let body = {};
let method = 'GET';

let urlPath: any = window.location.pathname;
let locale = 'da';
urlPath = urlPath.split("/");
if (urlPath && urlPath[1]) {
  locale = urlPath[1];
}

const d: any = document;
const otherUrl = d.getElementsByClassName("is-b2b").length ? 'b2b/' : ( d.getElementsByClassName("is-member-benefits").length ? 'memberBenefits/' : '' );

interface ConstantVariables {
  headers?: any;
  body?: any;
  data?: any;
  params?: any;
  method?: any;
  url?: any;
}


// let urlOrigin = "/";
//
// if (!window.location.origin) {
//   urlOrigin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '/');
// } else {
//   urlOrigin = window.location.origin + "/";
// }

export const API_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '/');

// const SUCCESS_STATUS_CODE = [200, 201, 202];
const headers = {
  'Content-Type': 'application/json',
};

async function connectAPI(url: string): Promise<any> {
  const resPromise = new Promise(async (resolve, reject) => {
    const options: ConstantVariables = {
      method,
      headers,
      url,
    };

    if (Object.keys(body).length !== 0 && body.constructor === Object) {
      options.data = body;
    }

    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      options.params = params;
    }

    if (isDebug) {
      // tslint:disable-next-line: no-console
      console.log('API Params:', options);
    }

    let response = null;

    response = await axios(options).then((res) => res ).catch(e => e.response);

    if (response.status === 500) {
      const err = {
        status: 500,
        error: {
          message: 'Internal Server Error',
        },
      };

      reject(err);

    } else if (response.status !== 200) {
      reject(response.data);
    } else {
      resolve(response.data);
    }
  });

  return resPromise;
}

export const API = {
  searchFormData() {
    const url = `${API_URL}api/v1/search/formData/${locale}/`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  search(bParams: any) {
    const url = `${API_URL}api/v1/search/results/${locale}/${otherUrl}`;
    params = {};
    body = bParams;
    method = 'POST';

    return connectAPI(url);
  },
  getUser(): Promise<{ result: object }> {
    const url = `${API_URL}api/v1/user/show/`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  addFavorite(userUid: number): Promise<{ result: object }> {
    const url = `${API_URL}api/v1/user/addFavorite/`;
    params = {};
    body = { favorite: userUid };
    method = 'POST';

    return connectAPI(url);
  },
  removeFavorite(userUid: number): Promise<{ result: object }> {
    const url = `${API_URL}api/v1/user/removeFavorite/${userUid}/`;
    params = {};
    body = {};
    method = 'DELETE';

    return connectAPI(url);
  },
};
